<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template #activator="{on}">
      <v-btn
        text
        icon
        color="primary"
        class="text-capitalize font-weight-bold"
        v-on="on"
      >
        <v-icon class="">mdi-information</v-icon>
      </v-btn>
    </template>
    <v-card :loading="loading">
      <v-card-title
        class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
      >
        <span class="pa-0">Detail</span>
        <v-spacer></v-spacer>
        <v-btn color="white" fab x-small depressed>
          <v-icon
            @click="dialog = false"
            color="primary"
            class="fs-18 font-weight-bold"
          >
            close
          </v-icon>
        </v-btn>
      </v-card-title>
      <VuePerfectScrollbar
        class="drawer-menu--scrollEdit"
        :settings="scrollSettingsEdit"
      >
        <v-card-text class="pb-0">
          <v-container class="pt-0">
            <v-row class="pt-0">
              <v-icon color="primary" class="pt-0 bg-info">description</v-icon>
              <span class="pl-2 font-weight-medium subtitle-1 darkblue--text"
                >Supporting Documents Details</span
              >
              <v-simple-table
                class="spending-table mb-2 mt-2"
                id="convertedTable"
              >
                <template v-slot:default>
                  <thead>
                    <tr class="primary">
                      <th class="f-14 white--text text-center" width="30%">
                        Name
                      </th>
                      <th class="f-14 white--text text-center" width="50%">
                        File
                      </th>
                      <th class="f-14 white--text text-center">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <VuePerfectScrollbar
                    class="drawer-menu--scroll"
                    :settings="scrollSettings"
                  >
                    <tbody>
                      <tr v-if="docs.length < 1">
                        <td colspan="3" class="text-center textlightgrey--text">
                          No data displayed
                        </td>
                      </tr>
                      <tr v-else v-for="item in docs" :key="item.id">
                        <td class="f-14 py-2 black--text" width="30%">
                          {{ item.name ? item.name : '-' }}
                        </td>
                        <td
                          class="py-2 text-truncate"
                          :title="item.url"
                          width="50%"
                        >
                          {{ item.url ? item.url : '-' }}
                        </td>
                        <td class="text-center py-2">
                          <v-btn
                            x-small
                            class="ma-2"
                            fab
                            dark
                            color="secondblue"
                            @click="downloadFile(item)"
                          >
                            <v-icon x-small>mdi-cloud-download</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </VuePerfectScrollbar>
                </template>
              </v-simple-table>
            </v-row>
          </v-container>
        </v-card-text>
      </VuePerfectScrollbar>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { saveAs } from 'file-saver';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    header: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    dialog: false,
    loading: false,
    scrollSettings: {
      maxScrollbarLength: 260
    },
    scrollSettingsEdit: {
      maxScrollbarLength: 220
    }
  }),
  computed: {
    ...mapState('sshcf', ['formRequest']),
    document() {
      return this.formRequest?.document || [];
    },
    docs() {
      return ['invoice', 'mou', 'proposal', 'summary_of_prevalidation'].map(
        name => ({
          key: name,
          name: this.document[`${name}_name`],
          url: this.document[`${name}_url`]
        })
      );
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.fetch();
      }
    }
  },
  methods: {
    async fetch() {
      this.loading = true;
      await this.$store.dispatch(
        'sshcf/getFormRequestDetail',
        this.item.form_id
      );
      this.loading = false;
    },
    downloadFile(item) {
      saveAs(item.url);
    }
  }
};
</script>
